import { render, staticRenderFns } from "./companyuser.vue?vue&type=template&id=14adb370"
import script from "./companyuser.vue?vue&type=script&lang=js"
export * from "./companyuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports